import { render } from "./TransferDetail.vue?vue&type=template&id=d67d436a&scoped=true"
import script from "./TransferDetail.vue?vue&type=script&lang=js"
export * from "./TransferDetail.vue?vue&type=script&lang=js"

import "./TransferDetail.vue?vue&type=style&index=0&id=d67d436a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d67d436a"]])

export default __exports__